import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import './timeline-selector.styl';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { trackEvent } from '@services/analytics.service';

import theme from '@css/theme.style.json';

const DISABLED_COLOR = '#888';

function TimelineSelector({
  options,
  selectedOption,
  onChange,
  disabledIndex,
}) {
  const { t } = useTranslation();

  if (!options || options.length === 0) {
    return null;
  }

  const selectedIndex = options.findIndex(option => option.id === selectedOption.id);

  const handleSliderChange = (value) => {
    // Prevent selecting disabled index
    if (disabledIndex !== undefined && value === disabledIndex) {
      return;
    }

    const selectedOptionData = options[value];
    if (selectedOptionData) {
      onChange(selectedOptionData);
      trackEvent(`timeline_selector_changed_to_${selectedOptionData.id}`);
    }
  };

  const marks = options.reduce((acc, option, index) => {
    const isDisabled = disabledIndex !== undefined && index === disabledIndex;

    acc[index] = {
      style: {
        color: isDisabled ? DISABLED_COLOR : 'black',
        fontWeight: selectedOption === option.id ? theme.typography.font.weight.bold : theme.typography.font.weight.regular,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      },
      label: t(option.label),
    };
    return acc;
  }, {});

  return (
    <div className="timeline-selector">
      <Slider
        min={0}
        max={options.length - 1}
        step={1}
        value={selectedIndex >= 0 ? selectedIndex : 0}
        marks={marks}
        onChange={handleSliderChange}
        included={false}
        styles={{
          rail: {
            backgroundColor: 'black',
            height: 2,
          },
          track: {
            backgroundColor: 'transparent',
            height: 2,
          },
          handle: {
            border: '2px solid black',
            backgroundColor: theme.color.secondary.main,
            borderRadius: '50%',
            height: 14,
            width: 14,
            bottom: 1,
            opacity: 1,
            boxShadow: 'none',
          },
        }}
        dotStyle={(index) => {
          const isDisabled = disabledIndex !== undefined && index === disabledIndex;
          return {
            border: isDisabled ? `1px solid ${DISABLED_COLOR}` : '1px solid black',
            backgroundColor: isDisabled ? DISABLED_COLOR : 'black',
            borderRadius: '50%',
            height: 12,
            width: 12,
            bottom: -3,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          };
        }}
      />
    </div>
  );
}

export default TimelineSelector;